import { Fragment, useMemo } from "react";
import { linkify, type LinkPart } from "@/lib/linkify";

interface Props {
  text: string;
  /** Builds a link for a phone-looking token (e.g. wa.me); omit to leave numbers as text. */
  phoneHref?: (raw: string) => string | null;
  onLinkClick?: (part: Extract<LinkPart, { type: "link" }>) => void;
}

/** A chat message body with web addresses and phone numbers turned into links. */
const LinkifiedText = ({ text, phoneHref, onLinkClick }: Props) => {
  const parts = useMemo(() => linkify(text, { phoneHref }), [text, phoneHref]);
  return (
    <>
      {parts.map((p, i) =>
        p.type === "text" ? (
          <Fragment key={i}>{p.value}</Fragment>
        ) : (
          <a
            key={i}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 break-all"
            onClick={() => onLinkClick?.(p)}
          >
            {p.label}
          </a>
        ),
      )}
    </>
  );
};

export default LinkifiedText;
